import { Loader2, X } from "lucide-react";
import { Button } from "../ui/button";
import { ETKINLIK_TUR_STYLES } from "../../lib/calendarUtils";

const TITLES = {
    randevu: "Randevu",
    hatirlatma: "Hatırlatma",
    takvim: "Takvim Etkinliği",
};

export default function CalendarEventModal({ open, mode, form, setForm, saving, onClose, onSubmit, onDelete }) {
    if (!open || !form) return null;

    const isEdit = mode === "edit";
    const tip = form.tip || "randevu";

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
            <button type="button" className="absolute inset-0 bg-black/70" onClick={onClose} aria-label="Kapat" />
            <form
                onSubmit={onSubmit}
                className="relative w-full max-w-lg rounded-2xl border-2 border-[#c9a961]/50 bg-[#faf6ee] text-[#1a2744] p-6 space-y-4 shadow-2xl max-h-[90vh] overflow-y-auto"
            >
                <div className="flex items-center justify-between">
                    <h2 className="font-display text-lg text-[#1a2744]">
                        {isEdit ? "Düzenle" : "Yeni"} — {TITLES[tip]}
                    </h2>
                    <button type="button" onClick={onClose} className="text-[#8b7355] hover:text-[#1a2744]">
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <input
                    required
                    placeholder="Başlık *"
                    value={form.baslik || ""}
                    onChange={(e) => setForm((f) => ({ ...f, baslik: e.target.value }))}
                    className="w-full rounded-lg border border-[#c9a961]/30 bg-white px-3 py-2 text-sm"
                />

                {tip === "randevu" && (
                    <>
                        <div className="grid grid-cols-2 gap-3">
                            <label className="text-xs text-[#8b7355]">
                                Başlangıç *
                                <input
                                    type="datetime-local"
                                    required
                                    value={form.baslangic || ""}
                                    onChange={(e) =>
                                        setForm((f) => ({ ...f, baslangic: e.target.value }))
                                    }
                                    className="mt-1 w-full rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-sm"
                                />
                            </label>
                            <label className="text-xs text-[#8b7355]">
                                Bitiş *
                                <input
                                    type="datetime-local"
                                    required
                                    value={form.bitis || ""}
                                    onChange={(e) => setForm((f) => ({ ...f, bitis: e.target.value }))}
                                    className="mt-1 w-full rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-sm"
                                />
                            </label>
                        </div>
                        <div className="grid grid-cols-3 gap-2">
                            <select
                                value={form.gorusme_tipi || "gorusme"}
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, gorusme_tipi: e.target.value }))
                                }
                                className="rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-xs"
                            >
                                <option value="gorusme">Yüz yüze</option>
                                <option value="telefon">Telefon</option>
                                <option value="online">Online</option>
                                <option value="diger">Diğer</option>
                            </select>
                            <select
                                value={form.onem || "orta"}
                                onChange={(e) => setForm((f) => ({ ...f, onem: e.target.value }))}
                                className="rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-xs"
                            >
                                <option value="dusuk">Düşük</option>
                                <option value="orta">Orta</option>
                                <option value="yuksek">Yüksek</option>
                            </select>
                            <select
                                value={form.durum || "planlandi"}
                                onChange={(e) => setForm((f) => ({ ...f, durum: e.target.value }))}
                                className="rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-xs"
                            >
                                <option value="planlandi">Planlandı</option>
                                <option value="tamamlandi">Tamamlandı</option>
                                <option value="iptal">İptal</option>
                            </select>
                        </div>
                        <input
                            placeholder="Konum"
                            value={form.konum || ""}
                            onChange={(e) => setForm((f) => ({ ...f, konum: e.target.value }))}
                            className="w-full rounded-lg border border-[#c9a961]/30 bg-white px-3 py-2 text-sm"
                        />
                    </>
                )}

                {tip === "hatirlatma" && (
                    <>
                        <label className="text-xs text-[#8b7355] block">
                            Hatırlatma zamanı *
                            <input
                                type="datetime-local"
                                required
                                value={form.hatirlatma_zamani || ""}
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, hatirlatma_zamani: e.target.value }))
                                }
                                className="mt-1 w-full rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-sm"
                            />
                        </label>
                        <select
                            value={form.yontem || "sistem"}
                            onChange={(e) => setForm((f) => ({ ...f, yontem: e.target.value }))}
                            className="w-full rounded-lg border border-[#c9a961]/30 bg-white px-3 py-2 text-sm"
                        >
                            <option value="sistem">Panel bildirimi</option>
                            <option value="eposta">E-posta</option>
                            <option value="sms">SMS</option>
                            <option value="whatsapp">WhatsApp</option>
                        </select>
                        {isEdit && (
                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={!!form.gonderildi_mi}
                                    onChange={(e) =>
                                        setForm((f) => ({ ...f, gonderildi_mi: e.target.checked }))
                                    }
                                />
                                Gönderildi olarak işaretle
                            </label>
                        )}
                    </>
                )}

                {tip === "takvim" && (
                    <>
                        <div className="grid grid-cols-2 gap-3">
                            <label className="text-xs text-[#8b7355]">
                                Başlangıç *
                                <input
                                    type="datetime-local"
                                    required
                                    value={form.baslangic || ""}
                                    onChange={(e) =>
                                        setForm((f) => ({ ...f, baslangic: e.target.value }))
                                    }
                                    className="mt-1 w-full rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-sm"
                                />
                            </label>
                            <label className="text-xs text-[#8b7355]">
                                Bitiş
                                <input
                                    type="datetime-local"
                                    value={form.bitis || ""}
                                    onChange={(e) => setForm((f) => ({ ...f, bitis: e.target.value }))}
                                    className="mt-1 w-full rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-sm"
                                />
                            </label>
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                            <select
                                value={form.etkinlik_turu || "DIGER"}
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, etkinlik_turu: e.target.value }))
                                }
                                className="rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-xs"
                            >
                                {Object.entries(ETKINLIK_TUR_STYLES).map(([k, v]) => (
                                    <option key={k} value={k}>
                                        {v.label}
                                    </option>
                                ))}
                            </select>
                            <select
                                value={form.tur || "TEK_GUN"}
                                onChange={(e) => setForm((f) => ({ ...f, tur: e.target.value }))}
                                className="rounded-lg border border-[#c9a961]/30 bg-white px-2 py-1.5 text-xs"
                            >
                                <option value="TEK_GUN">Tek gün</option>
                                <option value="SUREC">Süreç (aralık)</option>
                            </select>
                        </div>
                    </>
                )}

                <textarea
                    placeholder="Açıklama / not"
                    rows={3}
                    value={form.aciklama || ""}
                    onChange={(e) => setForm((f) => ({ ...f, aciklama: e.target.value }))}
                    className="w-full rounded-lg border border-[#c9a961]/30 bg-white px-3 py-2 text-sm"
                />

                <div className="flex gap-2 justify-between pt-2">
                    <div>
                        {isEdit && onDelete && (
                            <Button
                                type="button"
                                variant="outline"
                                className="text-rose-600 border-rose-300 hover:bg-rose-50"
                                onClick={onDelete}
                                disabled={saving}
                            >
                                Sil
                            </Button>
                        )}
                    </div>
                    <div className="flex gap-2">
                        <Button type="button" variant="outline" onClick={onClose}>
                            İptal
                        </Button>
                        <Button
                            type="submit"
                            disabled={saving}
                            className="bg-[#1a2744] hover:bg-[#111c4a] text-[#f5ecd6]"
                        >
                            {saving ? (
                                <Loader2 className="h-4 w-4 animate-spin" />
                            ) : isEdit ? (
                                "Güncelle"
                            ) : (
                                "Kaydet"
                            )}
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
}
